/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as import0 from '@angular/core';
import * as import1 from 'ng2-translate/src/translate.pipe';
import * as import2 from 'ng2-translate/src/translate.service';
import * as import3 from '@angular/common';
import * as import4 from '../../string-utils/currency.pipe';
import * as import5 from './order-extras-panel.component';
const styles_OrderExtrasPanelComponent:any[] = ([] as any[]);
export const RenderType_OrderExtrasPanelComponent:import0.RendererType2 = import0.ɵcrt({
  encapsulation: 2,
  styles: styles_OrderExtrasPanelComponent,
  data: {}
}
);
function View_OrderExtrasPanelComponent_2(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),4,'div',[[
        'class',
        'extras-total'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '\n        ',
      '\n    '
    ]
    )),
    import0.ɵppd(1),
    import0.ɵpod(['total']),
    import0.ɵpid(131072,import1.TranslatePipe,[
      import2.TranslateService,
      import0.ChangeDetectorRef
    ]
    )
  ]
  ,(null as any),(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = import0.ɵunv(v,1,0,import0.ɵnov(v,4).transform('woa.label.extras.extrasTotal',ck(v,3,0,import0.ɵunv(v,1,0,ck(v,2,0,import0.ɵnov((<any>(<any>v.parent).parent),0),co.item.initiatedExtrasTotal)))));
    ck(v,1,0,currVal_0);
  });
}
function View_OrderExtrasPanelComponent_5(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'div',[[
        'class',
        'extras-extra-qty'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '',
      ''
    ]
    ))
  ]
  ,(null as any),(ck,v) => {
    const currVal_0:any = (<any>(<any>v.parent).parent).context.$implicit.quantity;
    ck(v,1,0,currVal_0);
  });
}
function View_OrderExtrasPanelComponent_4(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),12,(null as any),(null as any),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n            '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),9,'div',[[
        'class',
        'extras-extra'
      ]
      ],[[
        8,
        'id',
        0
      ]
    ],(null as any),(null as any),(null as any),(null as any))),
    import0.ɵdid(278528,(null as any),0,import3.NgClass,[
      import0.IterableDiffers,
      import0.KeyValueDiffers,
      import0.ElementRef,
      import0.Renderer
    ]
    ,{
      klass: [
        0,
        'klass'
      ]
      ,
      ngClass: [
        1,
        'ngClass'
      ]

    }
    ,(null as any)),
    import0.ɵpod([
      'single-select',
      'nested'
    ]
    ),
    (l()(),import0.ɵted((null as any),['\n                '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_OrderExtrasPanelComponent_5)),
    import0.ɵdid(16384,(null as any),0,import3.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n                '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'div',[[
        'class',
        'extras-extra-item'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '',
      ''
    ]
    )),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵted((null as any),['\n        ']))
  ]
  ,(ck,v) => {
    const currVal_1:any = 'extras-extra';
    const currVal_2:any = ck(v,4,0,(<any>v.parent).context.$implicit.isGroup,(<any>v.parent).context.$implicit.isNested);
    ck(v,3,0,currVal_1,currVal_2);
    const currVal_3:any = ((<any>v.parent).context.$implicit.quantity > 1);
    ck(v,7,0,currVal_3);
  },(ck,v) => {
    const currVal_0:any = import0.ɵinlineInterpolate(1,'extra-',(<any>v.parent).context.index,'');
    ck(v,2,0,currVal_0);
    const currVal_4:any = (<any>v.parent).context.$implicit.name;
    ck(v,10,0,currVal_4);
  });
}
function View_OrderExtrasPanelComponent_3(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),4,(null as any),(null as any),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_OrderExtrasPanelComponent_4)),
    import0.ɵdid(16384,(null as any),0,import3.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n    ']))
  ]
  ,(ck,v) => {
    const currVal_0:any = v.context.$implicit.isVisible;
    ck(v,3,0,currVal_0);
  },(null as any));
}
function View_OrderExtrasPanelComponent_1(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),7,'div',[[
        'class',
        'extras'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_OrderExtrasPanelComponent_2)),
    import0.ɵdid(16384,(null as any),0,import3.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_OrderExtrasPanelComponent_3)),
    import0.ɵdid(802816,(null as any),0,import3.NgForOf,[
      import0.ViewContainerRef,
      import0.TemplateRef,
      import0.IterableDiffers
    ]
      ,{ngForOf: [
        0,
        'ngForOf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = (co.showTotal && co.item.initiatedExtrasTotal);
    ck(v,3,0,currVal_0);
    const currVal_1:any = co.item.orderedExtras;
    ck(v,6,0,currVal_1);
  },(null as any));
}
export function View_OrderExtrasPanelComponent_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    import0.ɵpid(0,import4.CurrencyPipe,([] as any[])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_OrderExtrasPanelComponent_1)),
    import0.ɵdid(16384,(null as any),0,import3.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n']))
  ]
  ,(ck,v) => {
    var co:import5.OrderExtrasPanelComponent = v.component;
    const currVal_0:any = co.item.orderedExtras.length;
    ck(v,2,0,currVal_0);
  },(null as any));
}
function View_OrderExtrasPanelComponent_Host_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'woa-order-extras-panel',([] as any[]),(null as any),(null as any),(null as any),View_OrderExtrasPanelComponent_0,RenderType_OrderExtrasPanelComponent)),
    import0.ɵdid(49152,(null as any),0,import5.OrderExtrasPanelComponent,([] as any[]),(null as any),(null as any))
  ]
  ,(null as any),(null as any));
}
export const OrderExtrasPanelComponentNgFactory:import0.ComponentFactory<import5.OrderExtrasPanelComponent> = import0.ɵccf('woa-order-extras-panel',import5.OrderExtrasPanelComponent,View_OrderExtrasPanelComponent_Host_0,{
  item: 'item',
  showTotal: 'showTotal'
}
,{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// ./src/app/order/order-extras-panel/order-extras-panel.component.ngfactory.ts